import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';

const useConfigContext = (config) => {
  const userContext = new useContext(ConfigContext);
  return userContext?.[config];
};

export default useConfigContext;
